<template>
  <div>我的课程</div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
